import template from './announcement.html';
import { IMAGE_OPTIONS } from '../share-move.constants';
import { ENTITY_KINDS } from '../../../../constants';
import './announcement.global.css';

const isMainImage = image => item => (item || {}).mainImage === image;
const isGraphic = isMainImage(IMAGE_OPTIONS.GRAPHIC);
const isMap = isMainImage(IMAGE_OPTIONS.MAP);

const SOCIAL_LINKS = [
  {
    name: 'facebook',
    urlProp: 'facebook_url',
  },
  {
    name: 'twitter',
    urlProp: 'twitter_url',
  },
  {
    name: 'linkedin',
    urlProp: 'linkedin_url',
  },
  {
    name: 'home',
    urlProp: 'website',
  },
];

class ShareMoveAnnouncementController {
  constructor() {
    this.socialLinks = SOCIAL_LINKS;
  }

  get isGraphic() {
    return isGraphic(this.item);
  }

  get isMap() {
    return isMap(this.item);
  }

  isAgent({ kind }) {
    return kind === ENTITY_KINDS.AGENT;
  }

  isCobrandedAgent({ kind }) {
    return kind === ENTITY_KINDS.COBRANDED_AGENT;
  }

  isCompany(entity) {
    return entity.is_company || entity.is_division;
  }

  isProfessional(entity) {
    return this.isAgent(entity) || this.isCobrandedAgent(entity);
  }

  isUpdater({ kind }) {
    return kind === ENTITY_KINDS.UPDATER;
  }

  getBrandingTransformType(entity) {
    return this.isCompany(entity) ? 'share_company' : 'share_agent';
  }
}

export const ShareMoveAnnouncementComponent = {
  template,
  controller: ShareMoveAnnouncementController,
  bindings: {
    entities: '<',
    item: '<',
    isPublic: '<',
  },
};
